import React from "react";
import styled from "styled-components";

import { UIPane } from "js/react/components/UiComponents";
import { UIPaneResultsContainer } from "js/react/views/AddSlide/Panes/Components/SearchBox";

type TeamResourcesUIPaneProps = React.PropsWithChildren<{
    className?: string;
    style?: React.CSSProperties;
}>;

const TypedUIPane = UIPane as React.ComponentType<TeamResourcesUIPaneProps>;

export const TeamResourcesUIPane = styled(TypedUIPane)`
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    flex: 1;
    padding: 24px 20px 0;
    display: flex;
    flex-direction: column;
`;

export const TeamResourcesResultsContainer = styled(UIPaneResultsContainer)`
    && {
        box-sizing: border-box;
        width: 100%;
        margin-top: 0;
        padding: ${({ $hasTopSpacing }: { $hasTopSpacing?: boolean }) => $hasTopSpacing ? "20px 0 0" : "0"};
        overflow-y: auto;
    }
`;
